import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./lib/auth";
import { queryClient } from "./lib/query-client";
import { App } from "./app/App";
import "./i18n/index";
import "@fontsource-variable/inter";
import "./index.css";

// SPA entry (KOMP-101). The query client is outermost: the auth context
// clears it at logout and when a session ends, so the next person at the same
// device starts from nothing cached ([AC-051]).
const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found");
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
